import appConstants from "../../../appConstants";
import { getSvgIcons } from "../../modules/Dispatch/utils/iconsUtil";
import { getCodIconTooltip } from "../../modules/Dispatch/utils/utils";
import { getCustomerAndShipperComment, getExcessiveLengthCodeTooltip } from "../../modules/utils";
import { hasHoldRM } from "../../modules/IBPlanning/RoutesView/utils";
import { createDowSpecialNeeds } from "../../../utilities/dowUtils";

const getCombinedIconsArray = ({shipmentData,specialNeedsOptions, planDate}) => {
  // Create a dictionary from appConstant's SpecialNeeds Object Array
  // where key is special need code and value is entire object
  const specialNeeds = {};
  specialNeedsOptions.forEach(data => (specialNeeds[data.value] = data));

  // Combined icons array contains all the icons which the given shipment satisfy
  const combinedIconsArray = [];

   if(shipmentData.isOnHoldRM || hasHoldRM(shipmentData)){
      combinedIconsArray.push(specialNeeds[appConstants.SpecialNeedsStrings.HoldRM]);
   }else if(shipmentData.isOnHold){
     combinedIconsArray.push(specialNeeds[appConstants.SpecialNeedsStrings.Hold]);
   }    
  
  // Insert the icon for APT shipment
  if (shipmentData.apt === 'APT') {
    let tooltip = '';
    if (shipmentData.aptComments) {
      tooltip = (
        <>
          {specialNeeds['APT']['tooltip']}
          <br />
          {shipmentData.aptComments}
        </>
      );
    }
    combinedIconsArray.push({ ...specialNeeds['APT'], ...(tooltip && { tooltip }) });
  }

  // Insert the icon for the Shipment Priority
  shipmentData.priority &&
    specialNeeds[shipmentData.priority] &&
    combinedIconsArray.push(specialNeeds[shipmentData.priority]);

  if (shipmentData.isLgViolation) {
    // If the isLgViolation is true, show only LG override icon
    combinedIconsArray.push(specialNeeds[appConstants.SpecialNeedsStrings.LiftGateOverride]);
  } else if(shipmentData.liftgate){
    // If liftgate needed, show that icon
    combinedIconsArray.push(specialNeeds["L"]);
  }

  // Insert the icon for Cod
  if (shipmentData.isCodCharge || shipmentData.isFreightCharge) {
    const tooltip = getCodIconTooltip(shipmentData.isCodCharge, shipmentData.isFreightCharge);
    combinedIconsArray.push({
      ...specialNeeds[appConstants.SpecialNeedsStrings.COD],
      tooltip
    });
  };

  // Insert the icon for Pup and Bobtail
  const preferences = ["Pup", "PupLG", "StraightTruckLG", "StraightTruck"];
  const eqpmtPrefArray = (shipmentData.eqpmtPref || shipmentData.eqptPref || '').split(',');

  eqpmtPrefArray.forEach((pref) => {
    if (preferences.includes(pref)) {
      combinedIconsArray.push(specialNeeds[pref]);
    }
  });  
  /*
  Insert the icon for special instruction
  conditional matching of both field are required as getCombinedIconsArray used for shipmentPopupInfo, stopPopupInfo
  */
  (shipmentData.specialInstruction || shipmentData.shipmentSpecialInstruction) &&
    combinedIconsArray.push(specialNeeds["specialInstruction"]);

  if (shipmentData.excessiveLength === appConstants.EXCESSIVE_SHIPMENT.YES) {
    const iconDetails = specialNeeds[appConstants.SpecialNeedsStrings.ExcessiveLength];
    const tooltip = getExcessiveLengthCodeTooltip({
      baseTooltip: iconDetails?.tooltip,
      excessiveLengthCode: shipmentData.excessiveLengthCode
    });
    combinedIconsArray.push({
      ...iconDetails,
      tooltip
    });
  }

  (shipmentData.isTrailerBackFill === appConstants.TRAILER_BACKFILL.YES &&
    combinedIconsArray.push(
      specialNeeds[appConstants.SpecialNeedsStrings.TrailerBackFill]
    )
  );

  if(shipmentData.isUnattendedDelivery){
    combinedIconsArray.push(specialNeeds[appConstants.SpecialNeedsStrings.Unattended]);
  }

  // Array of special need codes; Fill by splitting CSV string
  const specialNeedsCodes = [];
  shipmentData.specialNeeds &&
    shipmentData.specialNeeds
      .split(",")
      .map(specialNeed => specialNeedsCodes.push(specialNeed));

  // Insert the icons for special instruction
  specialNeedsCodes.forEach(code => {
    if (specialNeeds[code]) {
      if(code === appConstants.SpecialNeedsStrings.RESUNA && shipmentData.isUnattendedDelivery){
        // Avoid adding RESUNA icon if it's an unattended delivery as it is already added above
        return;
      }

      combinedIconsArray.push(specialNeeds[code]);
    }
  });

  shipmentData.isTwoManRequired && combinedIconsArray.push(specialNeeds[appConstants.SpecialNeedsStrings.TwoMan]);
  shipmentData.isCargoVanEligible && combinedIconsArray.push(specialNeeds[appConstants.SpecialNeedsStrings.CargoVan]);
  shipmentData.isLiveUnLoad && combinedIconsArray.push(specialNeeds[appConstants.SpecialNeedsStrings.LiveUnload]);
  shipmentData.isWhiteGloveDelivery && combinedIconsArray.push(specialNeeds[appConstants.SpecialNeedsStrings.WhiteGloveDelivery]);
  shipmentData.isNinvPro && combinedIconsArray.push(specialNeeds[appConstants.SpecialNeedsStrings.NINV]);
  shipmentData.isPhysicalDrRequired && combinedIconsArray.push(specialNeeds[appConstants.SpecialNeedsStrings.PhysicalDR]);
  shipmentData.isExhibitPro && combinedIconsArray.push(specialNeeds[appConstants.SpecialNeedsStrings.ExhibitPickup]);
  //customer/shipper comments

  const { customerComments, shipperComments } = getCustomerAndShipperComment(shipmentData);

  if (customerComments) {
    combinedIconsArray.push({
      ...specialNeeds[appConstants.SpecialNeedsStrings.CC],
      tooltip: customerComments
    });
  } else if (shipperComments) {
    combinedIconsArray.push({
      ...specialNeeds[appConstants.SpecialNeedsStrings.SC],
      tooltip: shipperComments
    });
  }

  // Add DOW special needs if deliveryDowOpen is present
  if (shipmentData.deliveryDowOpen) {
    const dowSpecialNeeds = createDowSpecialNeeds(shipmentData.deliveryDowOpen, planDate);
    if (dowSpecialNeeds) {
      combinedIconsArray.push(dowSpecialNeeds);
    }
  }

  return combinedIconsArray;
};

const getIconByType = ({ iconData, backgroundColor}) => {
  if (iconData?.svgIcon) {
    return getSvgIcons({iconName: iconData.svgIcon, backgroundColor , label: iconData.text});
  }
  return <i className={iconData.icon} />;
};

const getPickupStopWithPickupList = (data) => {
  const pickupNumberIdList = data.pickupNumberIdList?.map((pickup) => ({
    pickupNumber: pickup.pickupNumber,
    pickupId: pickup.pickupId,
    isPrimary: data.pickupId === pickup.pickupId
  })) || [];

  return {...data, pickupNumberIdList};
};

 
export {
  getCombinedIconsArray,
  getIconByType,
  getPickupStopWithPickupList
};
